import { post } from '../../http'


export default {
    /**
     * 取得 presigned URL
     * @param {File} fileObj - 檔案物件
     * @returns {Promise<{upload_url: string, r2_key: string, expires_at: string}>}
     */
    async getSignedUrl(fileObj) {
        const response = await post('/api/files/signed-url', {
            filename: fileObj.name,
            content_type: fileObj.type
        });

        if (response.data.status !== 200) {
            throw new Error('Failed to get signed URL');
        }

        return response.data.data;
    },
    /**
     * 上傳檔案到 R2 (使用 presigned URL)
     * @param {string} uploadUrl - presigned URL
     * @param {File} fileObj - 檔案物件
     */
    async uploadToR2(uploadUrl, fileObj) {
        const response = await fetch(uploadUrl, {
            method: 'PUT',
            body: fileObj,
            headers: {
                'Content-Type': fileObj.type || 'application/octet-stream'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to upload file to R2');
        }
    },
    /**
     * 確認上傳並移動檔案到最終路徑
     * @param {string} r2Key - 臨時檔案的 R2 key
     * @param {string} originalName - 原始檔案名稱
     * @param {string} destPath - 目標路徑 (e.g. 'invoice', 'attachments')
     * @returns {Promise<{path: string, url: string, originalName: string}>}
     */
    async confirmUpload(r2Key, originalName, destPath) {
        const response = await post('/api/files/upload', {
            r2_key: r2Key,
            original_name: originalName,
            path: destPath
        });

        if (response.data.status !== 200) {
            throw new Error('Failed to confirm upload');
        }

        return response.data.data;
    },
    /**
     * 完整的 presigned URL 上傳流程
     * @param {File} fileObj - 檔案物件
     * @param {string} destPath - 目標路徑 (e.g. 'invoice', 'attachments')
     * @returns {Promise<{path: string, url: string, originalName: string}>}
     */
    async uploadWithSignedUrl(fileObj, destPath) {
        // Step 1: 取得 presigned URL
        const { upload_url, r2_key } = await this.getSignedUrl(fileObj);

        // Step 2: 上傳到 R2
        await this.uploadToR2(upload_url, fileObj);

        // Step 3: 確認上傳並移動到最終路徑
        const result = await this.confirmUpload(r2_key, fileObj.name, destPath);

        return result;
    }
}
